<div class="form-box" *ngIf="quote">
  <div class="main-title">
    Installation Quote
  </div>

  <div class="project-info">
    <div class="project-info-line user-name">
      <span class="info-title">Contractor:</span>
      <span class="info-line project-name">{{quote.addresseeName}}</span>
    </div>
    <div class="project-info-line project-name">
      <span class="info-title">Job:</span>
      <span class="info-line project-name">{{quote.jobName}}</span>
    </div>
    <div class="project-info-line project-date">
      <span class="info-title">Installation Date:</span>
      <span class="info-line project-date">{{quote.installationDate | date: 'MMM dd, yyyy'}}</span>
    </div>
  </div>

  <app-quote-files [quote]="quote" [quoteCode]="quoteCode"></app-quote-files>

  <div class="buttons-block">

    <div class="input-block">
      <div class="input-frame">
        <input pInputText BlockLateralArrowNavigation type="number" class="amount-text-input" placeholder="Amount"
               [(ngModel)]="quote.price" [disabled]="quoteSent">
      </div>

      <button mat-button class="submit-btn" [disabled]="quoteSent || !quote.price" (click)="sendQuote()">
        <ng-container *ngIf="sendLoading">
          <lib-mini-progress-spinner></lib-mini-progress-spinner>
        </ng-container>

        <ng-container *ngIf="!sendLoading">
          <ng-container *ngIf="!quoteSent">
            Send
          </ng-container>
          <ng-container *ngIf="quoteSent">
            Sent
          </ng-container>
        </ng-container>
      </button>
    </div>

  </div>
</div>

<div class="form-box" *ngIf="!quote">
  <div class="main-title">
    Quote Not Found
  </div>
  <div class="buttons-block">
    <div class="drawing-block">
      <button mat-button class="drawing-btn" (click)="openSystem()">Open System</button>
    </div>

  </div>
</div>

